import React from 'react';

const Pay = () => {
    return (
        <section className="App">
            <h4 className="text-info">coming soon...</h4>
            <div style={{width:'80%',margin: 'auto'}}>
            <img style={{maxWidth: '80%'}} src="https://image.freepik.com/free-vector/payment-information-concept-illustration_114360-2296.jpg" alt="" />
            </div>
        </section>
    );
};

export default Pay;